export interface FieldDef<TDraft, TKind extends string> {
	key: keyof TDraft;
	label: string;
	kind: TKind;
	optional?: boolean;
	hint?: string;
	condition?: (draft: TDraft) => boolean;
}

export function visibleFields<TDraft, F extends FieldDef<TDraft, string>>(
	fields: F[],
	draft: TDraft,
): F[] {
	return fields.filter((field) => !field.condition || field.condition(draft));
}
